// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"group-form_tabContent_1gQNr"};